import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { CountUp } from 'countup.js';
import VisibilitySensor from 'react-visibility-sensor';
import { inject, observer } from 'mobx-react';

import Box from '../Atoms/Box';
import PreviewCompatibleImage from '../Atoms/PreviewCompatibleImage';
import Paragraph from '../Atoms/Paragraph';
import CustomLink from '../Atoms/CustomLink';
import theme from '../../styles/theme';

@inject('uiStore')
@observer
class HighlightItem extends Component {
  countUp;

  id = Math.random().toString(36).substring(7);

  onVisibilityChange = (isVisible) => {
    if (isVisible && this.countUp) {
      this.countUp.start();
    }
  };

  componentDidMount() {
    const { number } = this.props;
    if (number) {
      this.countUp = new CountUp(`${this.id}-${number}`, number);
    }
  }

  render() {
    const {
      title, icon, number, label, desc, url, uiStore, ...rest
    } = this.props;

    return (
      <Box {...rest}>
        {icon && (
          <Box textAlign="center">
            <PreviewCompatibleImage
              imageInfo={icon}
              imageStyle={{ width: '65px', height: '65px', margin: 'auto' }}
            />
          </Box>
        )}
        {number && (
          <Box>
            {!uiStore.cms && (
            <VisibilitySensor onChange={this.onVisibilityChange} delayedCall>
              <Box
                display="inline"
                id={`${this.id}-${number}`}
                width="100%"
                fontSize={[32, 32, 40]}
              />
            </VisibilitySensor>
            )}
            {uiStore.cms && <Box display="inline" width="100%" fontSize={[32, 32, 40]}>{number}</Box>}
            <Box as="span" fontSize={[32, 32, 40]}>
              +
            </Box>
          </Box>
        )}
        {title && title !== '' && <Paragraph fontSize={[3, 3, 4]} pb={[1, 1, 2]} fontWeight={600}>{title}</Paragraph>}
        {label && label !== '' && (
          <Paragraph pb={[1, 1, 2]}>
            {label}
          </Paragraph>
        )}
        {desc && <Paragraph fontSize={1}>{desc}</Paragraph>}
        {url && (
          <Box width="100%">
            <CustomLink to={url}>
              <Box fontSize={1}>
                <FormattedMessage id="highlight:learnMore" defaultMessage="Learn More" />
              </Box>
            </CustomLink>
          </Box>
        )}
      </Box>
    );
  }
}

export default HighlightItem;
